"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
require("./base-portfolio.component.scss");
var idm_de_service_client_js_1 = require("@synisys/idm-de-service-client-js");
var router_1 = require("@angular/router");
var entity_form_resolver_service_1 = require("@synisys/idm-portfolio-control/app/controls/portfolio/entity-form-resolver.service");
var base_portfolio_form_resolver_service_1 = require("./base-portfolio-form-resolver.service");
var operators_1 = require("rxjs/operators");
var ReplaySubject_1 = require("rxjs/ReplaySubject");
var base_portfolio_helper_service_1 = require("../../common/service/base-portfolio-helper.service");
var column_type_1 = require("@synisys/idm-portfolio-control/app/controls/model/column-type");
var root_category_summary_page_config_service_1 = require("../../../../shared/services/api/summary-pages/root-category-summary-page-config-service");
var dynamic_navigation_helper_1 = require("../../common/utils/dynamic-navigation-helper");
var url_and_query_params_1 = require("../../../../shared/utils/url-and-query-params");
var BasePortfolioComponent = /** @class */ (function () {
    function BasePortfolioComponent(route, router, cdRef, rootCategorySummaryPageConfigService, permissionService, basePortfolioHelperService) {
        this.route = route;
        this.router = router;
        this.cdRef = cdRef;
        this.rootCategorySummaryPageConfigService = rootCategorySummaryPageConfigService;
        this.permissionService = permissionService;
        this.basePortfolioHelperService = basePortfolioHelperService;
        this.isReady = false;
        this.isPortfolioReady = false;
        this.replaySubjects = [];
        this.destroy$ = new ReplaySubject_1.ReplaySubject(1);
    }
    BasePortfolioComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.route.params.pipe(operators_1.takeUntil(this.destroy$)).subscribe(function () {
            // re-render component on navigation
            _this.isReady = false;
            _this.setParameters();
            _this.cdRef.detectChanges();
            _this.isReady = true;
        });
    };
    BasePortfolioComponent.prototype.setParameters = function () {
        this.rootCategoryId = dynamic_navigation_helper_1.getPropertyFromUrl(url_and_query_params_1.UrlAndQueryParams.rootCategoryId, this.route);
        this.rootEntityId = dynamic_navigation_helper_1.getNumericPropertyFromUrl(url_and_query_params_1.UrlAndQueryParams.rootEntityId, this.route);
        this.categoryId = dynamic_navigation_helper_1.getPropertyFromUrl(url_and_query_params_1.UrlAndQueryParams.categoryId, this.route) || this.rootCategoryId;
        this.hasCreatePermission$ = this.permissionService.hasCreatePermissionByCategory(this.categoryId);
    };
    BasePortfolioComponent.prototype.changePortfolioConfigs = function (config) {
        this.isPortfolioReady = false;
        this.cdRef.detectChanges();
        this.updatePortfolioConfigs(config);
    };
    BasePortfolioComponent.prototype.updatePortfolioConfigs = function (config) {
        var _this = this;
        var defaultFilter$ = this.basePortfolioHelperService.generateDefaultFilter(this.rootCategoryId, this.rootEntityId, this.categoryId, config);
        this.title$ = this.rootCategorySummaryPageConfigService.getCardConfigByCategory(this.categoryId, this.rootCategoryId)
            .pipe(operators_1.map(function (conf) { return conf ? conf.title : undefined; }), operators_1.publishReplay(1), operators_1.refCount());
        this.portfolioConfig$ = defaultFilter$.pipe(operators_1.switchMap(function (defaultFilter) {
            return _this.basePortfolioHelperService.constructBasePortfolio(config, _this.categoryId, _this.rootCategoryId, defaultFilter);
        }), operators_1.tap(function (configs) {
            configs.portfolioConfig.columns.filter(function (column) { return column.columnType === column_type_1.ColumnType.TEMPLATE; })
                .forEach(function (templateColumn) {
                _this.replaySubjects.push(templateColumn.template$);
            });
            _this.cdRef.detectChanges();
            _this.afterFieldsInit();
        }));
        this.isPortfolioReady = true;
    };
    BasePortfolioComponent.prototype.afterFieldsInit = function () {
        var _this = this;
        this.replaySubjects.forEach(function (replaySubject, index) {
            replaySubject.next(_this.viewContainerRefs.toArray()[index]['_data']['template']);
        });
    };
    BasePortfolioComponent.prototype.ngOnDestroy = function () {
        this.destroy$.next(true);
        this.destroy$.complete();
    };
    __decorate([
        core_1.ViewChildren('customComponentContainer', { read: core_1.ViewContainerRef }),
        __metadata("design:type", core_1.QueryList)
    ], BasePortfolioComponent.prototype, "viewContainerRefs", void 0);
    BasePortfolioComponent = __decorate([
        core_1.Component({
            selector: 'ejustice-base-portfolio',
            template: require('./base-portfolio.component.html'),
            styles: [require('./base-portfolio.component.css')],
            providers: [{ provide: entity_form_resolver_service_1.EntityFormResolverService, useClass: base_portfolio_form_resolver_service_1.BasePortfolioFormResolverService }]
        }),
        __metadata("design:paramtypes", [router_1.ActivatedRoute,
            router_1.Router,
            core_1.ChangeDetectorRef,
            root_category_summary_page_config_service_1.RootCategorySummaryPageConfigService,
            idm_de_service_client_js_1.DePermissionService,
            base_portfolio_helper_service_1.BasePortfolioHelperService])
    ], BasePortfolioComponent);
    return BasePortfolioComponent;
}());
exports.BasePortfolioComponent = BasePortfolioComponent;
//# sourceMappingURL=base-portfolio.component.js.map